module.exports = __webpack_public_path__ + "static/uniesp-ac806ee8e1eb1b85ad1ae5fe200adafb.png";